import { SUPPORTED_NETWORKS } from "../networks";

export type PortfolioNft = {
  data?: {
    name: string;
    description: string;
    imageUrl: string;
    animationUrl?: string;
    attributes: Record<string, string | number>;
    collection: {
      name: string;
      imageUrl: string;
      creator: string;
    };
  };
  amount?: number;
  tokenId: string;
  tokenAddress: string;
  owner?: string;
  network: SUPPORTED_NETWORKS;
};
